import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';

import { DxArtifact, DxOs } from '../lib/types';
import { DxSetupApi } from './DxSetupApi';

type Params = Record<string, string | number | boolean | null | undefined>;

export class DxSetupClient implements DxSetupApi {
  private proxyBaseUrl?: Promise<string>;

  private constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  private getProxyBaseUrl(): Promise<string> {
    return (this.proxyBaseUrl ??= this.discoveryApi.getBaseUrl('proxy'));
  }

  public static create({
    discoveryApi,
    fetchApi,
  }: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }): DxSetupClient {
    return new DxSetupClient(discoveryApi, fetchApi);
  }

  public async getAiCodeInsightsCurrentVersion(os?: DxOs) {
    const params: Params = {};

    if (os) {
      params.os = os;
    }

    return this.get<DxArtifact>('/aiCodeInsights.currentVersion', params);
  }

  private async get<T = any>(path: string, params: Params): Promise<T> {
    const proxyBaseUrl = await this.getProxyBaseUrl();

    const url = new URL(`${proxyBaseUrl}/dx-data-cloud-api/api${path}`);

    for (const [key, value] of Object.entries(params)) {
      if (value !== null && value !== undefined) {
        url.searchParams.append(key, value.toString());
      }
    }

    const response = await this.fetchApi.fetch(url, { method: 'GET' });

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }

    return await response.json();
  }
}
